import axiosInstance from '@libs/axios';

/**
 * Pulls the filename out of a Content-Disposition header, preferring the
 * RFC 5987 `filename*=UTF-8''…` form the backend sends.
 */
export const filenameFromDisposition = (header: string | undefined, fallback: string): string => {
  if (!header) return fallback;
  const star = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1].trim());
    } catch {
      return fallback;
    }
  }
  const plain = header.match(/filename="?([^";]+)"?/i);
  return plain?.[1]?.trim() || fallback;
};

/** Downloads an authenticated xlsx and hands it to the browser. */
export async function downloadXlsx(url: string, fallbackName: string): Promise<void> {
  const response = await axiosInstance.get<Blob>(url, { responseType: 'blob' });
  const disposition = (response.headers?.['content-disposition'] as string | undefined) ?? undefined;
  const filename = filenameFromDisposition(disposition, fallbackName);
  const objectUrl = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
}
